<template>
  <div class="entityItem-container">
    <div class="item-wrapper borderTop">
      <div class="item-date">{{ date | dateFormat('Lllmm')}}</div>
      <div class="item-content">
        <img class="content-img" :src="img" />
        <div class="content-info">
          <div class="info-title">{{ title }}</div>
          <div class="info-desc">{{ desc }}</div>
          <div class="info-card">
            <div class="card-name">{{ expNo && expNo.length > 0 ? '快递单号：' : '暂无快递信息' }}</div>
            <div class="card-no" v-if="expNo && expNo.length > 0">{{ expNo }}</div>
            <div class="card-copy" v-if="expNo && expNo.length > 0" @click="copyExpNo">复制</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'entityItem',
    props: {
        date: Number,
        title: String,
        desc: String,
        expNo: String,
        img: String
    },
    data() {
        return {};
    },
    methods: {
        copyExpNo() {
            this.$copyText(this.expNo).then(() => {
                this.$toast({ message: '复制成功', duration: 2000 });
            }, () => {
                this.$toast({ message: '复制失败', duration: 2000 });
            });
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../../../common/style/borderLine.scss';
.entityItem-container {
  width: 100%;
  height: 122px;
  background: #ffffff;
  @include border-line-style(#F5F8FA);
  .item-wrapper {
    padding: 12px 24px 18px 18px;
    .item-date {
      font-size: 12px;
      // font-family: fzlt;
      font-weight: normal;
      color: rgba(159, 170, 181, 1);
      line-height: 12px;
    }
    .item-content {
      display: flex;
      display: -webkit-flex;
      margin-top: 18px;
      overflow: hidden;
      .content-img {
        width: 62px;
        height: 62px;
        flex-grow: 0;
        flex-shrink: 0;
        border-radius: 4px;
      }
      .content-info {
        padding-left: 20px;
        flex: 1;
        overflow: hidden;
        .info-title {
          margin-right: 80px;
          display: -webkit-box;
          overflow: hidden;
          text-overflow-ellipsis: ellipsis;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          font-size: 15px;
          line-height: 17px;
          // font-family: fzlt;
          font-weight: normal;
          color: rgba(0, 42, 60, 1);
        }
        .info-desc {
          margin-top: 8px;
          font-size:12px;
          // font-family:fzlt;
          font-weight:normal;
          color:rgba(159,170,181,1);
        }
        .info-card {
          margin-top: 15px;
          font-size:12px;
          // font-family:fzlt;
          font-weight:normal;
          color:rgba(73,89,108,1);
          display: flex;
          display: -webkit-flex;
          .card-name {
            flex-grow: 0;
            flex-shrink: 0;
            line-height: 14px;
          }
          .card-no {
            flex: 1;
            margin-right: 36px;
            overflow: hidden;
            word-wrap: break-word;
            display: -webkit-box;
            text-overflow-ellipsis: ellipsis;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            line-height: 14px;
          }
          .card-copy {
            width:32px;
            height:14px;
            background:rgba(247,247,247,1);
            border-radius:7px;
            flex-grow: 0;
            flex-shrink: 0;
            font-size:10px;
            // font-family:fzlt;
            font-weight:normal;
            color:rgba(37,77,94,1);
            line-height: 14px;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>
